import { useState } from "react";
import { Link } from "react-router-dom";
import { Mic2, FileText, Download } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { IMG } from "@/lib/images";
import { PageHeader, Section, Prose } from "@/components/Editorial";
import InviteModal from "@/components/InviteModal";

const THEMES = [
  "Histoire de l'ésotérisme", "Histoire des arts divinatoires", "Ésotérisme et histoire de France",
  "Occultisme et personnages historiques", "Mysticisme et traditions", "Pierres et couronnes royales",
  "Médiumnité", "Deuil et croyances autour de la mort", "Rêves et onirothérapie",
];
const PRACTICAL = [
  ["Formats", "Conférence, table ronde, rencontre, atelier"],
  ["Publics", "Salons, festivals, médiathèques, associations, entreprises"],
  ["Zone", "France — déplacements selon conditions"],
  ["Supports", "Présentation illustrée, échanges avec le public"],
];

export default function Pros() {
  const [invite, setInvite] = useState(false);

  useSeo({
    title: "Professionnels & Organisateurs",
    description: "Espace organisateurs : biographie courte, thématiques de conférences, photos, kit média téléchargeable et informations pratiques pour inviter Dorothée Lancelot.",
    path: "/professionnels",
  });

  return (
    <div>
      <PageHeader eyebrow="Espace organisateurs" title="Professionnels & Organisateurs" intro="Tout ce qu'il faut pour inviter Dorothée Lancelot : biographie, thématiques, visuels, kit média et informations pratiques." image={IMG.conference2} />

      <Section>
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-12">
          <div>
            <div className="dl-eyebrow mb-3">Biographie courte</div>
            <Prose>
              <p>
                Dorothée Lancelot est auteure, médium, conférencière et onirothérapeute. Elle explore l'ésotérisme
                par son histoire — origine des pratiques, contexte, évolution — et intervient lors de salons,
                conférences et rencontres. Son travail se décline à travers une bibliographie, des contenus suivis
                par une communauté fidèle, ainsi que le projet Les Chroniques de l'Étrange.
              </p>
            </Prose>

            <div className="dl-eyebrow mb-3 mt-10">Thématiques de conférences</div>
            <div className="flex flex-wrap gap-2.5">
              {THEMES.map((t) => <span key={t} className="px-4 py-2 text-sm border border-[rgba(198,167,106,0.25)] text-[#F3E9D2]/75">{t}</span>)}
            </div>

            <div className="dl-eyebrow mb-4 mt-10">Photos</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {[IMG.conference1, IMG.conference2, IMG.libraryCandle, IMG.gothic, IMG.scotland, IMG.map].map((src, i) => (
                <img key={i} src={src} alt="" className="w-full h-32 object-cover border border-[rgba(198,167,106,0.2)]" loading="lazy" />
              ))}
            </div>
          </div>

          <aside className="space-y-6">
            <div className="dl-card p-6">
              <Mic2 size={22} className="text-[#C6A76A] mb-4" />
              <h3 className="serif text-xl text-[#F3E9D2]">Inviter en conférence</h3>
              <p className="text-sm text-[#F3E9D2]/60 mt-2">Recevez les informations nécessaires en un clic.</p>
              <button data-testid="pros-invite-btn" onClick={() => setInvite(true)} className="dl-btn dl-btn-solid w-full justify-center mt-4">Inviter Dorothée</button>
              <Link to="/kit-media" className="dl-btn w-full justify-center mt-3"><FileText size={15} /> Kit média</Link>
            </div>

            <div className="dl-card p-6">
              <div className="dl-eyebrow mb-4">Informations pratiques</div>
              <dl className="space-y-3">
                {PRACTICAL.map(([k, v]) => (
                  <div key={k}>
                    <dt className="text-xs text-[#D4B978] uppercase tracking-wide">{k}</dt>
                    <dd className="text-sm text-[#F3E9D2]/75">{v}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </aside>
        </div>
      </Section>

      <InviteModal open={invite} onClose={() => setInvite(false)} />
    </div>
  );
}
